import React, { useState } from "react";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";

const Tooltip = ({ className, children, position, text }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => {
    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  const getTooltipClass = () => {
    switch (position) {
      case "left":
        return styles.tooltipLeft;
      case "right":
        return styles.tooltipRight;
      case "bottom":
        return styles.tooltipBottom;
      case "top":
      default:
        return styles.tooltipTop;
    }
  };

  return (
    <span
      className={styles.tooltipWrapper}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <span className={`${className}`}>{children}</span>
      {isVisible && (
        <span className={`${styles.tooltip} ${getTooltipClass()}`}>
          <span className={styles.tooltipText}>{text}</span>
        </span>
      )}
    </span>
  );
};

Tooltip.defaultProps = {
  className: "",
  position: "top"
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf(["top", "left", "right", "bottom"]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default Tooltip;
